
<template>
  <div class="mind-box">
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">运营策略管理</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="model-title">基本信息</div>
    <el-card class="box-card">
      <el-form label-width="100px" class="orderForm" size="small" label-suffix=":">
        <el-form-item label="决策树名称">
          <label>{{ strategyInfo.name }}</label>
        </el-form-item>
        <el-form-item label="备注">
          <label>{{ strategyInfo.remark }}</label>
        </el-form-item>
      </el-form>
    </el-card>
    <div ref="jsmind_container" class="jsmind-container"></div>
  </div>
</template>

<script>
import jsMind from 'jsmind'
// // import 'jsmind/draggable-node'
import 'jsmind/style/jsmind.css'
import {
  requestModules
} from '@r'
export default {
  data() {
    return {
      jsmind_options: {
        editable: false,
        theme: 'primary',
      },
      jsmind_data: {
        meta: {
          name: 'demo',
          author: 'test@example.com',
          version: '0.2',
        },
        format: 'node_tree',
        data: {}
      },
      strategyInfo: {}
    }
  },
  mounted() {
    this.getStrategyDetail();
  },
  methods: {
    getStrategyDetail() {
      requestModules.fetchStrategy({ id: this.$route.params.id }).then(res => {
        this.strategyInfo = res.mdata;
        this.strategyInfo.rules = JSON.parse(this.strategyInfo.rules);

        let ruleInfo = this.strategyInfo.rules[0];
        this.jsmind_data.data = {
          "id": this.strategyInfo._id,
          "topic": this.strategyInfo.name,
          isroot: true,
          children: this.strategyInfo.rules
        }
        let options = Object.assign(this.jsmind_options, {
          container: this.$refs.jsmind_container
        });
        let jm = new jsMind(options);
        jm.show(this.jsmind_data);

      })
    },
    initMindData() {

    }
  }
}
</script>

<style scoped  lang="scss">
.mind-box {
  .model-title {
    margin: 20px 10px;
    font-size: 18px;
    font-weight: bold;
  }
  .opreate-box {
    margin-top: 20px;
    margin-left: 20px;
  }
  .breadcrumb {
    margin: 20px 10px;
  }
  .jsmind-container {
    width: 100%;
    height: 800px;
  }
}
</style>

